<template>
  <div class="navbar-wrap" :style="themeVars">
    <van-nav-bar :left-arrow="!isTabs" :title="pageNames" @click-left="onClickLeft" fixed placeholder :border="false" z-index="999">
      <template #right>
        <template v-if="rightType">
          <div v-if="rightType == 'kefu'">
            <img src="../assets/icon/lxkf.png" alt="">
          </div>
          <div v-else class="right" @click="onClickRight">
            <van-icon class="right-icon" name="todo-list-o" size="20" />
            <!-- <div class="right-title">{{ rightType }}</div> -->
          </div>
        </template>
      </template>
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  name: "navbar",
  props: {
    isTabs: {
      type: Boolean,
      default: false
    },
    pageNames: {
      type: String,
      default: ""
    },
    backColors: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "light"
    },
    rightType: {
      type: String,
      default: ""
    },
    pathUrl: {
      type: String,
      default: ""
    },
  },
  computed: {
    themeVars() {
      const isDark = this.theme === "dark"
      return {
        "--nav-bg": this.backColors || (isDark ? "#0b0f16" : "#ffffff"),
        "--nav-fg": isDark ? "#ffffff" : "#000000"
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      this.$router.push(this.pathUrl)
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .van-nav-bar {
  background-color: var(--nav-bg);
  height: 45px;

  .van-nav-bar__left,
  .van-nav-bar__text,
  .van-nav-bar__arrow {
    color: var(--nav-fg);
  }

  .van-nav-bar__title {
    color: var(--nav-fg);
    font-size: 16px;
    font-weight: 600;
  }
}

.van-nav-bar--fixed {
  z-index: 999;
}

.navbar-wrap {
  width: 100%;
}

.right {
  display: flex;
  align-items: center;
}

.right-icon {
  color: var(--nav-fg) !important;
  font-size: 22px;
}

.right-title {
  color: var(--nav-fg);
  font-size: 16px;
  margin-left: 5px;
}
</style>
